import { CheckboxButtonProps } from './checkbox-button.types'
import styles from './checkbox-button.module.scss'
import cl from 'classnames'
import { Button, Checkbox, Text1 } from '@touche-lts/panel-ui/dist'

const CheckboxButtonComponent = (props: CheckboxButtonProps) => {
  const { className, style, checkboxProps, label, ...rest } = props

  return (
    <Button
      preset='icon'
      {...rest}
      className={cl(styles.container, className)}
      style={style}
    >
      <Checkbox {...checkboxProps} />
      {label && (
        <Text1 style={{ marginLeft: 10 }}>
          {label}
        </Text1>
      )}
    </Button>
  )
}

const CheckboxButton = CheckboxButtonComponent
export { CheckboxButton }
